import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Budget.css'
import Header from './layouts/Header'

class Budget extends Component {
  constructor(props) {
    super(props)

    this.state = {
      vvip: '',
      vip: '',
      general: '',
      priceOne: '',
      priceTwo: '',
      priceThree: '',
      calResults: '',
    }

    this.handleVVIP = this.handleVVIP.bind(this)
    this.handleVIP = this.handleVIP.bind(this)
    this.handleGeneral = this.handleGeneral.bind(this)
    this.handlePriceOne = this.handlePriceOne.bind(this)
    this.handlePriceTwo = this.handlePriceTwo.bind(this)
    this.handlePriceThree = this.handlePriceThree.bind(this)
    this.handleCalculation = this.handleCalculation.bind(this)
  }

  componentDidMount() {
    document.title = 'Karamale - Budget Calculator'
  }

  handleVVIP(event) {
    this.setState({
      vvip: event.target.value,
      calResults: '',
    })
  }

  handleVIP(event) {
    this.setState({
      vip: event.target.value,
      calResults: '',
    })
  }

  handleGeneral(event) {
    this.setState({
      general: event.target.value,
      calResults: '',
    })
  }

  handlePriceOne(event) {
    this.setState({
      priceOne: event.target.value,
      calResults: '',
    })
  }

  handlePriceTwo(event) {
    this.setState({
      priceTwo: event.target.value,
      calResults: '',
    })
  }

  handlePriceThree(event) {
    this.setState({
      priceThree: event.target.value,
      calResults: '',
    })
  }

  handleCalculation() {
    const { vvip, vip, general, priceOne, priceTwo, priceThree } = this.state

    if (vvip !== '' && priceOne === '') {
      this.setState({
        calResults: 'VVIP tickets require a ticket price.',
      })
      return
    }

    if (vvip === '' && priceOne !== '') {
      this.setState({
        calResults: 'VVIP ticket price requires a number of tickets.',
      })
      return
    }

    if (vip !== '' && priceTwo === '') {
      this.setState({
        calResults: 'VIP tickets require a ticket price.',
      })
      return
    }

    if (vip === '' && priceTwo !== '') {
      this.setState({
        calResults: 'VIP ticket price requires a number of tickets.',
      })
      return
    }

    if (general !== '' && priceThree === '') {
      this.setState({
        calResults: 'General tickets require a ticket price.',
      })
      return
    }

    if (general === '' && priceThree !== '') {
      this.setState({
        calResults: 'General ticket price requires a number of tickets.',
      })
      return
    }

    const serviceRate = 0.035

    const amountOne = Number(priceOne || 0) * serviceRate * Number(vvip || 0)

    const amountTwo = Number(priceTwo || 0) * serviceRate * Number(vip || 0)

    const amountThree = Number(priceThree || 0) * serviceRate * Number(general || 0)

    const total = amountOne + amountTwo + amountThree

    const formatToRand = (amount) => {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
      })
        .format(amount)
        .replace(/\s/g, '')
    }

    this.setState({
      calResults: `Your estimated budget is ${formatToRand(total)}`,
    })
  }

  render() {
    const { vvip, vip, general, priceOne, priceTwo, priceThree, calResults } = this.state

    const isLoggedIn =
      localStorage.getItem('businessname') !== null && localStorage.getItem('accounttype') !== null

    const actionButton = isLoggedIn ? (
      <Link
        to={{
          pathname: '/addevent',
          state: { prevpage: 'budget' },
        }}
        className="kx-budget__primary-link"
      >
        Create an event
      </Link>
    ) : (
      <Link to="/organiser-registration" className="kx-budget__primary-link">
        Get started
      </Link>
    )

    const hasResult = calResults.indexOf('Your estimated budget') === 0

    return (
      <div className="kx-budget">
        <Header />

        <main>
          <section className="kx-budget__hero">
            <div className="kx-budget__hero-grid"></div>

            <div className="kx-budget__hero-inner">
              <div className="kx-budget__hero-copy">
                <div className="kx-budget__eyebrow">
                  <span></span>
                  KARAMALE BUDGET PLANNER
                </div>

                <h1>
                  Know your budget
                  <strong>before you sell.</strong>
                </h1>

                <p>
                  Estimate the campaign budget you'll need based on your ticket categories,
                  quantities and prices.
                </p>

                <div className="kx-budget__hero-meta">
                  <div>
                    <strong>3.5%</strong>
                    <span>campaign service fee</span>
                  </div>

                  <div>
                    <strong>100%</strong>
                    <span>of ticket revenue stays yours</span>
                  </div>
                </div>
              </div>

              <div className="kx-budget__hero-card">
                <div className="kx-budget__hero-card-label">YOUR CAMPAIGN</div>

                <div className="kx-budget__hero-card-number">
                  3.5<span>%</span>
                </div>

                <p>
                  Karamale's service fee is calculated from your campaign budget — not from your
                  ticket revenue.
                </p>

                <div className="kx-budget__hero-card-line"></div>

                <span>Plan your spend. Sell with confidence.</span>
              </div>
            </div>
          </section>

          <section className="kx-budget__calculator-section">
            <div className="kx-budget__section-intro">
              <div>
                <span className="kx-budget__section-number">01</span>
                <h2>Build your estimate.</h2>
              </div>

              <p>
                Enter the number of tickets you expect to sell and the price of each ticket
                category. You only need to complete the categories that apply to your event.
              </p>
            </div>

            <div className="kx-budget__calculator-layout">
              <div className="kx-budget__calculator">
                <div className="kx-budget__calculator-header">
                  <div>
                    <span>Budget calculator</span>
                    <h3>What are you selling?</h3>
                  </div>

                  <div className="kx-budget__rate">
                    <strong>3.5%</strong>
                    <span>service rate</span>
                  </div>
                </div>

                <div className="kx-budget__ticket-list">
                  <div className="kx-budget__ticket-row kx-budget__ticket-row--featured">
                    <div className="kx-budget__ticket-name">
                      <span className="kx-budget__ticket-dot"></span>
                      <div>
                        <strong>VVIP</strong>
                        <small>Premium access</small>
                      </div>
                    </div>

                    <div className="kx-budget__field">
                      <label>Tickets</label>
                      <input
                        type="number"
                        min="0"
                        placeholder="0"
                        value={vvip}
                        onChange={this.handleVVIP}
                      />
                    </div>

                    <div className="kx-budget__field">
                      <label>Price per ticket</label>
                      <div className="kx-budget__input-wrap">
                        <span>R</span>
                        <input
                          type="number"
                          min="0"
                          placeholder="550"
                          value={priceOne}
                          onChange={this.handlePriceOne}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="kx-budget__ticket-row">
                    <div className="kx-budget__ticket-name">
                      <span className="kx-budget__ticket-dot"></span>
                      <div>
                        <strong>VIP</strong>
                        <small>Premium seating</small>
                      </div>
                    </div>

                    <div className="kx-budget__field">
                      <label>Tickets</label>
                      <input
                        type="number"
                        min="0"
                        placeholder="0"
                        value={vip}
                        onChange={this.handleVIP}
                      />
                    </div>

                    <div className="kx-budget__field">
                      <label>Price per ticket</label>
                      <div className="kx-budget__input-wrap">
                        <span>R</span>
                        <input
                          type="number"
                          min="0"
                          placeholder="150"
                          value={priceTwo}
                          onChange={this.handlePriceTwo}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="kx-budget__ticket-row">
                    <div className="kx-budget__ticket-name">
                      <span className="kx-budget__ticket-dot"></span>
                      <div>
                        <strong>General</strong>
                        <small>Standard admission</small>
                      </div>
                    </div>

                    <div className="kx-budget__field">
                      <label>Tickets</label>
                      <input
                        type="number"
                        min="0"
                        placeholder="0"
                        value={general}
                        onChange={this.handleGeneral}
                      />
                    </div>

                    <div className="kx-budget__field">
                      <label>Price per ticket</label>
                      <div className="kx-budget__input-wrap">
                        <span>R</span>
                        <input
                          type="number"
                          min="0"
                          placeholder="100"
                          value={priceThree}
                          onChange={this.handlePriceThree}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={this.handleCalculation}
                  className="kx-budget__calculate"
                >
                  Calculate my budget
                  <span>→</span>
                </button>

                {calResults && (
                  <div
                    className={`kx-budget__result ${
                      hasResult ? 'kx-budget__result--success' : 'kx-budget__result--error'
                    }`}
                  >
                    <span>{hasResult ? 'ESTIMATED CAMPAIGN BUDGET' : 'CHECK YOUR INPUT'}</span>

                    <strong>{calResults}</strong>
                  </div>
                )}
              </div>

              <aside className="kx-budget__side-note">
                <span className="kx-budget__side-note-number">02</span>

                <h3>
                  You're in
                  <strong>control.</strong>
                </h3>

                <p>
                  Your campaign budget is the amount you choose to make available for Karamale's
                  service fees.
                </p>

                <div className="kx-budget__side-points">
                  <div>
                    <span>01</span>
                    <p>Set your budget upfront.</p>
                  </div>

                  <div>
                    <span>02</span>
                    <p>Increase it whenever you need to.</p>
                  </div>

                  <div>
                    <span>03</span>
                    <p>Your ticket revenue remains yours.</p>
                  </div>
                </div>

                <div className="kx-budget__side-accent">
                  <span>3.5%</span>
                  <p>of campaign budget</p>
                </div>
              </aside>
            </div>
          </section>

          <section className="kx-budget__explanation">
            <div className="kx-budget__explanation-inner">
              <div className="kx-budget__explanation-title">
                <span className="kx-budget__section-number">03</span>
                <h2>How the budget works.</h2>
              </div>

              <div className="kx-budget__explanation-copy">
                <p className="kx-budget__lead">
                  Karamale uses your campaign budget to cover the 3.5% service fee whenever a
                  customer buys your ticket.
                </p>

                <div className="kx-budget__explanation-grid">
                  <div>
                    <span>01</span>
                    <h3>Customer buys</h3>
                    <p>
                      Your customer purchases a ticket through Karamale and receives their digital
                      ticket in their account.
                    </p>
                  </div>

                  <div>
                    <span>02</span>
                    <h3>Fee is calculated</h3>
                    <p>
                      The 3.5% service fee is calculated against the ticket transaction and covered
                      by your campaign budget.
                    </p>
                  </div>

                  <div>
                    <span>03</span>
                    <h3>You keep the revenue</h3>
                    <p>
                      The remaining ticket revenue belongs to you. A small payout processing fee
                      applies when you request a payout.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="kx-budget__pricing">
            <div className="kx-budget__pricing-header">
              <div>
                <span className="kx-budget__section-number">04</span>
                <h2>Ticket options.</h2>
              </div>

              <p>
                Digital tickets are delivered directly to the customer's Karamale account. Physical
                tickets are also available when your event requires them.
              </p>
            </div>

            <div className="kx-budget__pricing-grid">
              <div className="kx-budget__pricing-card kx-budget__pricing-card--digital">
                <div className="kx-budget__pricing-card-top">
                  <span>01</span>
                  <small>DIGITAL</small>
                </div>

                <h3>Online tickets</h3>

                <div className="kx-budget__pricing-highlight">
                  <strong>3.5%</strong>
                  <span>campaign service fee</span>
                </div>

                <ul>
                  <li>Instant digital delivery</li>
                  <li>QR code ticket</li>
                  <li>Ticket category & admission details</li>
                  <li>Unique ticket number</li>
                  <li>Customer ticket history</li>
                </ul>
              </div>

              <div className="kx-budget__pricing-card">
                <div className="kx-budget__pricing-card-top">
                  <span>02</span>
                  <small>PHYSICAL</small>
                </div>

                <h3>Self-print</h3>

                <div className="kx-budget__pricing-highlight">
                  <strong>R1.00</strong>
                  <span>per ticket</span>
                </div>

                <ul>
                  <li>Download your tickets</li>
                  <li>Print them yourself</li>
                  <li>Cost deducted from campaign budget</li>
                  <li>No separate invoice required</li>
                </ul>
              </div>

              <div className="kx-budget__pricing-card">
                <div className="kx-budget__pricing-card-top">
                  <span>03</span>
                  <small>PHYSICAL</small>
                </div>

                <h3>Printed by Karamale</h3>

                <div className="kx-budget__pricing-highlight">
                  <strong>R3.50</strong>
                  <span>per ticket</span>
                </div>

                <ul>
                  <li>Karamale prints the tickets</li>
                  <li>Ready for physical distribution</li>
                  <li>Cost deducted from campaign budget</li>
                  <li>No separate invoice required</li>
                </ul>
              </div>
            </div>
          </section>

          <section className="kx-budget__digital-note">
            <div className="kx-budget__digital-note-number">05</div>

            <div>
              <span>EVERYTHING IN ONE PLACE</span>

              <h2>
                Sell online.
                <br />
                <strong>Know what you're making.</strong>
              </h2>
            </div>

            <p>
              Karamale gives you the tools to sell, manage and monitor your event while keeping your
              ticket revenue and campaign spending clearly separated.
            </p>
          </section>

          <section className="kx-budget__cta">
            <div className="kx-budget__cta-inner">
              <span>READY WHEN YOU ARE</span>

              <h2>
                Plan it.
                <strong>Launch it.</strong>
              </h2>

              <p>Start with your numbers, set your budget and get your event moving.</p>

              {actionButton}
            </div>
          </section>
        </main>
      </div>
    )
  }
}

export default Budget
